const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?\d{7,15}$/;
const UK_VAT_REGEX = /^(GB)?(\d{9}(\d{3})?|GD\d{3}|HA\d{3})$/;
const UK_CRN_REGEX = /^(?:\d{8}|(?:SC|NI|OC|SO|NC|IP|RC|SR|NR|ZC|NP|NF)\d{6})$/;

export function validateEmail(value: string): string | null {
  if (!value) return null;
  return EMAIL_REGEX.test(value) ? null : 'Please enter a valid email address';
}

export function validatePhone(value: string): string | null {
  if (!value) return null;
  const stripped = value.replace(/[\s\-()]/g, '');
  return PHONE_REGEX.test(stripped) ? null : 'Please enter a valid phone number';
}

export function validateUkVat(value: string): string | null {
  if (!value) return null;
  const normalised = value.replace(/\s/g, '').toUpperCase();
  return UK_VAT_REGEX.test(normalised)
    ? null
    : 'VAT number does not look like a valid UK VAT number — please double-check.';
}

export function validateUkCrn(value: string): string | null {
  if (!value) return null;
  const normalised = value.replace(/\s/g, '').toUpperCase();
  return UK_CRN_REGEX.test(normalised)
    ? null
    : 'Company registration number does not look like a valid UK registration number — please double-check.';
}
